export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  searchHeader: {
    marginLeft: 15,
    fontSize: 14,
    fontWeight: 600,
    marginBottom: "1rem",
    color: "#606060",
  },
  sidebarContainer: {
    
  }
});
